var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3509_29653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.68154 12.9583V11.7481C9.68154 11.1062 9.42654 10.4906 8.97263 10.0367C8.51872 9.58276 7.90309 9.32776 7.26116 9.32776H3.63059C2.98866 9.32776 2.37303 9.58276 1.91912 10.0367C1.46521 10.4906 1.21021 11.1062 1.21021 11.7481V12.9583",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44577 6.90741C6.78251 6.90741 7.86615 5.82377 7.86615 4.48703C7.86615 3.15029 6.78251 2.06665 5.44577 2.06665C4.10903 2.06665 3.02539 3.15029 3.02539 4.48703C3.02539 5.82377 4.10903 6.90741 5.44577 6.90741Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3121 12.9586V11.7485C13.3117 11.2122 13.1332 10.6912 12.8047 10.2674C12.4761 9.84353 12.0161 9.54081 11.4968 9.40674",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68164 2.14526C10.2023 2.27857 10.6637 2.58136 10.9933 3.0059C11.3228 3.43044 11.5017 3.95258 11.5017 4.49001C11.5017 5.02744 11.3228 5.54958 10.9933 5.97412C10.6637 6.39866 10.2023 6.70145 9.68164 6.83475",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3509_29653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.5223,
    height: 14.5223,
    fill: "white",
    transform: "translate(0 0.251465)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.6712624aa1649ec2af7684091a441f66.svg";
export { ForwardRef as ReactComponent };